<template>
  <a v-scroll-to="'#landForm'" class="btn btnLand" @click="$emit('click')">
    {{$t('qic_landing_get_quote_button')}}
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.93313 1.28574C9.5235 0.876108 8.85935 0.876108 8.44973 1.28574C8.0401 1.69537 8.0401 2.35951 8.44973 2.76914L14.0016 8.32097H1.84897C1.26967 8.32097 0.800049 8.79059 0.800049 9.36989C0.800049 9.9492 1.26967 10.4188 1.84897 10.4188H14.0016L8.44973 15.9706C8.0401 16.3803 8.0401 17.0444 8.44973 17.454C8.85935 17.8637 9.5235 17.8637 9.93313 17.454L17.2756 10.1116C17.6852 9.70196 17.6852 9.03782 17.2756 8.62819L9.93313 1.28574Z" fill="#F1F4F6"/>
    </svg>
  </a>
</template>

<script>
export default {
  name: 'LandingGetQuoteButton',
  emits: ['click']
}
</script>

<style lang="scss" scoped>
.blink{
  overflow: hidden;
  position: relative;
}
.blink:before {
    content: '';
    background: #fff;
    opacity: .14;
    width: 90px;
    position: absolute;
    height: 100%;
    transform: skewX(-28deg);
    top: 0;
    left: -100px;
    animation-name: blinkbut;
    -webkit-animation-duration: 5s;
    animation-duration: 5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
}

.blink:after {
    content: '';
    background: #fff;
    opacity: .14;
    width: 30px;
    position: absolute;
    height: 100%;
    transform: skewX(-28deg);
    top: 0;
    left: -138px;
    animation-name: blinkbut1;
    -webkit-animation-duration: 5s;
    animation-duration: 5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
}

@-webkit-keyframes blinkbut {
    from {
        transform: translateX(-400px) skewX(-28deg);
    }
    to {
        transform: translateX(100px) skewX(-28deg);
    }
}

@keyframes blinkbut {
    from {
        transform: translateX(-400px) skewX(-28deg);
    }
    to {
        transform: translateX(1000px) skewX(-28deg);
    }
}
.blinkbut {
    -webkit-animation-name: blinkbut;
    animation-name: blinkbut;
}
@-webkit-keyframes blinkbut1 {
    from {
        transform: translateX(-400px) skewX(-28deg);
    }
    to {
        transform: translateX(100px) skewX(-28deg);
    }
}

@keyframes blinkbut1 {
    from {
        transform: translateX(-400px) skewX(-28deg);
    }
    to {
        transform: translateX(1000px) skewX(-28deg);
    }
}
.blinkbut1 {
    -webkit-animation-name: blinkbut1;
    animation-name: blinkbut1;
}
</style>
